import { HTTPErrorCallback } from "Helpers/Error";

import UseGlobalConfirm from "Hooks/UseGlobalConfirm";
import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "../Buttons";

const ToggleStatus = ({ item, route, refresh }) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();
  const { addGlobalConfirm } = UseGlobalConfirm();

  const changeStatus = async () => {
    try {
      setLoading(true);

      await api.put(`${route}${item?.id}`);

      setLoading(false);

      showNotification("success", "Sucesso!", "Item atualizado com sucesso!");

      refresh();
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  const variant = item?.inactivated_at ? "success" : "critical";
  const statusText = item?.inactivated_at ? "Ativar" : "Inativar";

  return (
    <Button
      variant={variant}
      type="button"
      text={statusText}
      onClick={(e) =>
        addGlobalConfirm({
          type: variant,
          title: `Deseja ${statusText.toLowerCase()} este item?`,
          message: "Confirme a atualização deste item: ",
          confirmText: `Sim, ${statusText.toLowerCase()}`,
          denyText: "Não, desejo voltar",
          onClickConfirm: () => {
            changeStatus();
          },
          onClickDeny: () => {
            e.stopPropagation();
          },
        })
      }
      disabled={loading}
    />
  );
};

export default ToggleStatus;
